import { searchFolderShape } from './fetchFavoritePersonaSearchFolder';
import constant from 'owa-service/lib/factory/constant';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import fieldURIOrConstantType from 'owa-service/lib/factory/fieldURIOrConstantType';
import findFolderRequest from 'owa-service/lib/factory/findFolderRequest';
import isEqualTo from 'owa-service/lib/factory/isEqualTo';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import restrictionType from 'owa-service/lib/factory/restrictionType';
import findFolderOperation from 'owa-service/lib/operation/findFolderOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { trace } from 'owa-trace';
function folderDisplayNameRestriction() {
    return isEqualTo({
        FieldURIOrConstant: fieldURIOrConstantType({
            Item: constant({
                Value: 'FavoritePersonas',
            }),
        }),
        Item: propertyUri({
            FieldURI: 'FolderDisplayName',
        }),
    });
}
function configureRequestBody() {
    return findFolderRequest({
        FolderShape: searchFolderShape(),
        Paging: null,
        ParentFolderIds: [distinguishedFolderId({ Id: 'root' })],
        ReturnParentFolder: true,
        ShapeName: 'Folder',
        Traversal: 'Deep',
        Restriction: restrictionType({
            Item: folderDisplayNameRestriction(),
        }),
    });
}
export default function retrieveRootFavoritePersonasFolder() {
    return findFolderOperation({
        Header: getJsonRequestHeader(),
        Body: configureRequestBody(),
    }).then(function (response) {
        var folders = response.Body.ResponseMessages.Items[0]
            .RootFolder.Folders;
        return new Promise(function (resolve, reject) {
            if (folders.length === 1) {
                resolve(folders[0]);
            }
            else if (folders.length > 1) {
                trace.warn('More than one "FavoritePersonas" folder found.');
                resolve(folders[0]);
            }
            else if (folders.length === 0) {
                resolve(undefined);
            }
            else {
                trace.error(response.Body.ResponseMessages.Items[0].MessageText);
                reject(response.Body.ResponseMessages.Items[0].MessageText);
            }
        });
    });
}
//# sourceMappingURL=retrieveRootFavoritePersonasFolder.js.map